// Types
import type { Location } from 'react-router-dom';
import type { NavigateOptions, To } from 'react-router';

export type HistoryDelta = number;
export type RouteTarget = To;

export type NavigateTarget = RouteTarget | HistoryDelta;

// Config
import { NAVIGATE, ROUTER_LOCATION_CHANGE } from '@constants/actionConstants';

export const navigateTo = (to: NavigateTarget, options?: NavigateOptions) => ({
  type: NAVIGATE,
  payload: { to, options },
});

export const goBack = (steps: number = 1) => navigateTo(-steps);
export const navigateReplace = (to: RouteTarget, options?: NavigateOptions) =>
  navigateTo(to, { ...options, replace: true });

export const locationChanged = (location: Location) => ({
  type: ROUTER_LOCATION_CHANGE,
  payload: { location: { ...location } },
});
